/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Form } from 'react-redux-form';
import ArrowButton from '../../../../common/button-arrow';
import { approveDamagedBarcodeSubmission, declineDamagedBarcodeSubmission } from '../../../../../actions/scans';
import RequiredInput from '../../../../common/form/elements/required-input';
import DamagedBarcodeSubmissionDeclineDialog from './damaged-barcode-submission-decline-dialog';

const model = 'deep.admin_damaged_barcode_submission_view';

class DamagedBarcodeSubmissionViewForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDialogOpen: false
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(actions.reset(model));
  }

  handleApprove = () => {
    const {
      id, product_code, outer_code, dispatch
    } = this.props;

    dispatch(approveDamagedBarcodeSubmission(id, { product_code, outer_code }));
  };

  handleOpenDialog = () => {
    this.setState({ isDialogOpen: true });
  };

  handleCloseDialog = () => {
    this.setState({ isDialogOpen: false});
  };

  handleConfirmDialog = (result) => {
    const { id, decline_reason, dispatch } = this.props;

    if (result) {
      dispatch(declineDamagedBarcodeSubmission(id, { decline_reason }));
      this.handleCloseDialog();
    } else {
      this.handleCloseDialog();
    }
  };

  render() {
    const { formValid } = this.props;
    const { isDialogOpen } = this.state;

    return (
      <div className="fluid">
        <Form model={model}>
          <RequiredInput
            controlId='product_code'
            label="Product code (EAN)"
            model='.product_code'
          />
          <RequiredInput
            controlId='outer_code'
            label="Outer code"
            model='.outer_code'
          />
        </Form>
        <ArrowButton
          arrow={false}
          submit={false}
          className="pull-right"
          onClick={this.handleOpenDialog}
        >
          Decline
        </ArrowButton>
        <ArrowButton
          arrow={false}
          submit={false}
          className="pull-right"
          onClick={this.handleApprove}
          disabled={!formValid}
        >
          Approve
        </ArrowButton>
        {isDialogOpen && (
          <DamagedBarcodeSubmissionDeclineDialog
            handleConfirmDialog={this.handleConfirmDialog }
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_damaged_barcode_submission_view.$form.valid,
  product_code: state.deep.forms.admin_damaged_barcode_submission_view.product_code.value,
  outer_code: state.deep.forms.admin_damaged_barcode_submission_view.outer_code.value,
  decline_reason: state.deep.forms.admin_damaged_barcode_dialog.decline_reason.value,
});

export default connect(mapStateToProps)(DamagedBarcodeSubmissionViewForm);



// WEBPACK FOOTER //
// ./src/components/admin/scans/damaged-barcode-submissions/view/damaged-barcode-submission-view-form.jsx